<template>
  <iColumn
    :width="getOptionValue(LayoutWidth) || 'fill'"
    height="hug"
    :style-overrides="appInputWrapperStyleOverrides"
  >
    <PlainStoryEditor
      :key="editorVersion"
      v-model="value"
      :height="getOptionValue(LayoutHeight)"
      :max-height="getOptionValue(MaxHeight)"
      :max-width="getOptionValue(MaxWidth)"
      :min-height="getOptionValue(MinHeight)"
      :min-width="getOptionValue(MinWidth)"
      :preview="!isEditable"
      :border-radius="appInputBorderRadius"
      :background-color="appInputBackgroundColor"
      :publication-id="useFanPublicationStore().publicationId"
      :use-border="isEditable"
      hide-segment-controls
      padding-left="none"
      padding-right="none"
      width="fill"
    />
  </iColumn>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import PlainStoryEditor from "%/dynamic-component-editor/components/PlainStoryEditor.vue";
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";

import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

export default {
  name: "DynamicAppStoryInputElement",
  components: { PlainStoryEditor },
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({
      "default.min-height": 100,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  data() {
    return {
      editorVersion: 0,
      lastWrittenDraft: undefined,
    };
  },
  computed: {
    MaxWidth() {
      return MaxWidth;
    },
    MaxHeight() {
      return MaxHeight;
    },
    MinWidth() {
      return MinWidth;
    },
    MinHeight() {
      return MinHeight;
    },
    LayoutHeight() {
      return LayoutHeight;
    },
    LayoutWidth() {
      return LayoutWidth;
    },
    isEditable() {
      return true;
    },
    value: {
      get() {
        try {
          return JSON.parse(this.valueFromContext);
        } catch (e) {
          return this.valueFromContext;
        }
      },
      set(value) {
        if (!this.editMode) {
          this.lastWrittenDraft = JSON.stringify(value);
          this.valueFromContext = this.lastWrittenDraft;
        }
      },
    },
  },
  watch: {
    valueFromContext(next) {
      if (!this.editMode && next !== this.lastWrittenDraft) {
        this.editorVersion += 1;
      }
    },
  },
  methods: { useFanPublicationStore },
};
</script>
